module.exports = __webpack_public_path__ + "img/icon-fishing-white.57271448.svg";